<template>
  <div class="navBox">
      <div class="name">
          <p class="">语文智能提分管理系统</p>
      </div>
      <div class="navList">
        <div class="navItem" v-for="item in navList" v-bind:key="item.id">
          <div class="item" :class="navID==item.id?'select':''" @click="navSub(item)">
            <i class="icon" :class="'icon'+item.id"></i>
            <p>{{item.label}}</p>
          </div>
          <div class="children two" v-if="item.showType">
            <div class="item" v-for="ele in item.children" v-bind:key="ele.id" :class="ele.id==childrenID?'select':''" @click.stop='childrenSub(ele)'>
              <p>{{ele.label}}</p>
              <div class="children three" v-if="ele.showType">
                <div class="item" v-for="(i,k) in ele.children" v-bind:key="k" :class="i.id==threeID?'select':''" @click.stop='threeSub(i)'>
                  <p>{{i.label}}</p>
                  <div class="children four " v-if="i.showType">
                    <div class="item" v-for="(l,n) in i.children" v-bind:key="l.id" :class="l.id==fourID?'select':''" @click.stop='fourSub(l)'>
                      <p>{{l.label}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
      name: 'navBox',
      data() {
        return {
          navList: [
            {
              id:1,
              label: '题库管理',
              showType:false,
              children: [{
                id:'1-1',
                label: '现代文阅读',
                showType:false,
                children: [
                  {
                  id:'1-1-1',
                  label: '迁移应用题库',
                  showType:false,
                  children: [{
                    id:'1-1-1-1',
                    label: '习题题库',
                    url:'/topicIndex',
                  },{
                    id:'1-1-1-2',
                    label: '母题题库',
                    url:'/topicVideo',
                  }]
                },
                {
                  id:'1-1-1',
                  label: '反向解题题库',
                  showType:false,
                  children: [{
                    id:'1-1-2-1',
                    label: '习题题库',
                    url:'/solveIndex',
                  },{
                    id:'1-1-2-2',
                    label: '母题题库',
                    url:'/solveVideo',
                  }]
                }]
              }]
            }, 
            {
              id:2,
              label: '作文管理',
              children: [{
                id:'2-1',
                label: '习题题库',
                url:'/compositionList'
              }]
            }, 
            {
              id:3,
              label: '标签管理',
              url:'/labelIndex'
            }, 
            
            {
              id:5,
              label: '学员管理',
              url:'/student'
            }, 
            {
              id:6,
              label: '老师管理',
              url:'/teacher'
            }, 
            {
              id:9,
              label: '考情管理',
              showType:false,
              children: [{
                id:'9-1',
                label: '考情诊断',
                url:'/studyIndex'
              },{
                id:'9-2',
                label: '历史学情',
                url:'/studyHistory'
              },{
                id:'9-3',
                label: '试卷管理',
                url:'/studyPaper'
              },{
                id:'9-4',
                label: '板块与考点管理',
                url:'/studyModule'
              }]
            }, 
            {
              id:8,
              label: '训练管理',
              children: [{
                id:'8-1',
                label: '训练营',
                url:'/marketIndex'
              }]
            }, 
            {
              id:7,
              label: '系统管理员',
              children: [{
                id:'7-1',
                label: '管理员信息',
                url:'/accounts'
              }]
            }, 
          ],
          navID:'',
          childrenID:'',
          threeID:'',
          fourID:'',
          userData:'',
          url:'',
          device:''
        };
      },
      props: {
        title: String,
        visible: {
          type: Boolean,
          default: false
        },
        id: String,
        cid: String,
        tid: String,
        fid: String,
      },
      mounted() {
        this.getUser();
        var that = this;
        this.navID = this.id;
        this.childrenID = this.cid;
        this.threeID = this.tid;
        this.fourID = this.fid;
        var list = this.navList;
        list.forEach(function(item,index){
          if(that.navID == item.id&&!item.children){
            document.title = item.label
          };
          if(item.children){
            item.children.forEach(function(ele,num){
              if(ele.id == that.childrenID){
                item.showType = true;
                document.title = ele.label;
              };
              if(ele.children){
                ele.children.forEach(function(i,k){
                  if(i.id == that.threeID){
                    ele.showType = true;
                    that.childrenID = '';
                    document.title = i.label;
                  }
                  if(i.children){
                    i.children.forEach(function(l,n){
                      if(l.id == that.fourID){
                        i.showType = true;
                        that.threeID = '';
                        document.title = l.label;
                      }
                      
                    })
                  }
                })
              }
            });
          };
        });
        this.$forceUpdate();
        var url = '';
        if(window.location.origin == 'https://intecls.zens10.com' || window.location.origin == 'http://localhost:8080'){
          url = 'https://lite.zens10.com/'
        } else {
          url = 'https://app.zens10.com/'
        };
        this.url = url;
      },
      methods: {
        navSub(e){
          var that = this;
          if(e.children){
            e.showType = !e.showType;
            this.childrenID = e.id;
          };
          this.navID = e.id;
          this.$forceUpdate();
          if(e.url){
            this.$router.push(e.url);
          };
        },

        childrenSub(e){
          if(e.url){
            this.$router.push(e.url);
          }else {
            if(e.children){
              e.showType = !e.showType;
            };
          };
          this.$forceUpdate();
        },

        threeSub(e){
          if(e.url){
            this.threeID = e.id;
            this.$router.push(e.url);
          } else {
            if(e.children){
              e.showType = !e.showType;
            };
          }
        },

        fourSub(e){
          if(e.url){
            this.threeID = e.id;
            this.$router.push(e.url);
          } else {
            if(e.children){
              e.showType = !e.showType;
            };
          }
        },

        getUser(){
          var that = this;
          var data = localStorage.getItem('userData');
          this.userData = JSON.parse(data);
          if(data == null){
            this.$message('请先登录！');
            this.$router.push('/');
            return false;
          }
          if(this.userData.level == 0){
            that.navList = [
              {
                id:8,
                label: '租户管理',
              }
            ]
          };
          if(this.userData.level == 3){
            that.navList=[
              {
                id:3,
                label: '标签管理',
                url:'/labelIndex'
              }, 
              
              {
                id:5,
                label: '学员管理',
                url:'/student'
              }, 
              {
                id:6,
                label: '老师管理',
                url:'/teacher'
              }, 
              {
                id:9,
                label: '考情管理',
                showType:false,
                children: [{
                  id:'9-1',
                  label: '考情诊断',
                  url:'/studyIndex'
                },{
                  id:'9-2',
                  label: '历史学情',
                  url:'/studyHistory'
                },{
                  id:'9-3',
                  label: '试卷管理',
                  url:'/studyPaper'
                },{
                  id:'9-4',
                  label: '板块与考点管理',
                  url:'/studyModule'
                }]
              }, 
              {
                id:8,
                label: '训练管理',
                children: [{
                  id:'8-1',
                  label: '训练营',
                  url:'/marketIndex'
                }]
              }, 
              {
                id:7,
                label: '系统管理员',
                children: [{
                  id:'7-1',
                  label: '管理员信息',
                  url:'/accounts'
                }]
              }, 
            ];
          }

        },
      }
  }
</script>
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/comment/nav.vue